import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { Box } from '@mui/system'
import {
    Chip,
    CircularProgress,
    Collapse,
    IconButton,
    LinearProgress,
    useTheme,
} from '@mui/material'
import { ChevronRight } from '@mui/icons-material'
import TV from '../../../../assets/icons/devices/Tv.svg'
import Document from '../../../../assets/icons/Documents/Document.svg'
import { capitalize } from '../../../../utils/functions'
import { sectionApiSlice } from '../../../../features/section/sectionSlice'
import { SectionState, UserTopicState } from '../../../../features/types'
import Section from './Section'

interface Props {
    topic: UserTopicState
    handleSelect: (topic: UserTopicState, section: SectionState) => void
    selectedSection: SectionState
}
const Topic: React.FC<Props> = ({ topic, selectedSection, handleSelect }) => {
    const theme = useTheme()
    const { locale } = useIntl()
    const [expanded, setExpanded] = useState(false)
    const { data: sections = [], isFetching: isFetchingSections } =
        sectionApiSlice.useGetTopicSectionsQuery(topic.courseTopicId, {
            skip: !expanded,
        })

    const styles = {
        wrapper: {
            border: `1px solid ${theme.palette.grey[100]}`,
            borderRadius: '8px',
            mb: 2,
        },
        container: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            background: theme.palette.grey[100],
            cursor: 'pointer',
            p: 1,
            pr: 2,
        },
        chevron: {
            transform: expanded ? 'rotate(90deg)' : 'rotate(0)',
            transition: '0.15s ease-in-out',
        },
        flexCenter: {
            display: 'flex',
            alignItems: 'center',
        },
    }

    return (
        <Box sx={styles.wrapper}>
            <Box
                sx={styles.container}
                onClick={() => setExpanded(!expanded)}
            >
                <Box
                    sx={styles.flexCenter}
                    style={{ width: '80%' }}
                >
                    <IconButton>
                        <ChevronRight sx={styles.chevron} />
                    </IconButton>

                    <Box
                        ml={1}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '4px',
                            // width: '100%',
                            flexGrow: 1,
                        }}
                    >
                        <Box
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                            }}
                        >
                            <Box sx={styles.flexCenter}>
                                {topic[`topicTitle${capitalize(locale)}`]}

                                <Chip
                                    sx={{ ml: 1 }}
                                    label={topic.language}
                                    size="small"
                                />
                            </Box>

                            <Box>{topic.percentage}%</Box>
                        </Box>

                        <Box>
                            <LinearProgress
                                variant="determinate"
                                color={'primary'}
                                value={topic.percentage}
                            />
                        </Box>
                    </Box>
                </Box>

                <Box sx={styles.flexCenter}>
                    <Box sx={styles.flexCenter}>
                        <img
                            alt={'tv'}
                            src={TV}
                        />
                        {topic.countVideo}
                    </Box>

                    <Box sx={{ ...styles.flexCenter, mr: 1, ml: 1 }}>
                        <img
                            alt={'document'}
                            src={Document}
                        />
                        {topic.countTest}
                    </Box>
                </Box>
            </Box>

            <Collapse in={expanded}>
                {isFetchingSections && <CircularProgress sx={{ m: 1 }} />}

                <Box>
                    {sections.map((section, index) => (
                        <Section
                            key={section.id}
                            section={section}
                            language={topic.language}
                            selectedSection={selectedSection}
                            isLast={index === sections.length - 1}
                            handleSelect={() => handleSelect(topic, section)}
                        />
                    ))}
                </Box>
            </Collapse>
        </Box>
    )
}

export default Topic
